import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { copyTextToClipboard } from "@faire/web--source/common/copyTextToClipboard";
import { getWebApiErrorMessage } from "@faire/web--source/common/getErrorMessage";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { optimizeImageUrlFillSquare } from "@faire/web--source/common/images/optimizeImages";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Button } from "@faire/web--source/slate/Button";
import { Link } from "@faire/web--source/slate/icons/foundation/Link";
import { TextArea } from "@faire/web--source/slate/Input/TextArea";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Modal } from "@faire/web--source/slate/Modal";
import { Spacer } from "@faire/web--source/slate/spacing";
import { createToast } from "@faire/web--source/slate/Toast";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { useMutation as useShareItemMutation } from "@faire/web-api--source/api/retailer/team/share/post-hooks";
import { useQuery as useMyTeamUsersQuery } from "@faire/web-api--source/api/retailer/team/share/users/get-hooks";
import { trackRetailerTeamManagementCopyLinkButtonClick } from "@faire/web-api--source/events/retailerTeamManagement/click/copyLinkButton";
import { trackRetailerTeamManagementSendEmailShareModalButtonClick } from "@faire/web-api--source/events/retailerTeamManagement/click/sendEmailShareModalButton";
import { IRetailerShareableItem } from "@faire/web-api--source/indigofair/retailer/IRetailerShareableItem";
import { IRetailerShareItemWithTeamMembersRequest } from "@faire/web-api--source/indigofair/retailer/IRetailerShareItemWithTeamMembersRequest";
import { ShareableItemType } from "@faire/web-api--source/indigofair/retailer/ShareableItemType";
import React, { useState } from "react";
import styled from "styled-components";
import { SelectTeamUsersDropdown } from "@faire/retailer/views/multi-user/Share/__internal__/SelectTeamUsersDropdown";
import { TOAST_AUTO_DISMISS_TIME_MS } from "@faire/retailer/views/multi-user/Share/consts";
export var ShareWithTeamModal = function(param) {
    var modalType = param.modalType, image = param.image, name = param.name, subText = param.subText, token = param.token, onClose = param.onClose, showCopyLinkButton = param.showCopyLinkButton, onInviteButtonClick = param.onInviteButtonClick, pageName = param.pageName;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _React_useState = _sliced_to_array(React.useState(""), 2), note = _React_useState[0], setNote = _React_useState[1];
    var isSSR = useIsSSR();
    var viewport = useViewport();
    var _useState = _sliced_to_array(useState([]), 2), selectedUsers = _useState[0], setSelectedUsers = _useState[1];
    var _useState1 = _sliced_to_array(useState(undefined), 2), errorMessage = _useState1[0], setErrorMessage = _useState1[1];
    var _useState2 = _sliced_to_array(useState(undefined), 2), dropdownErrorMessage = _useState2[0], setDropdownErrorMessage = _useState2[1];
    var _useMyTeamUsersQuery = useMyTeamUsersQuery(), data = _useMyTeamUsersQuery.data, isLoadingTeamsData = _useMyTeamUsersQuery.isPending;
    var _useShareItemMutation = useShareItemMutation(), shareItem = _useShareItemMutation.mutateAsync, isLoadingSendEmail = _useShareItemMutation.isPending;
    var getModalTitle = function() {
        switch(modalType){
            case ShareableItemType.BRAND_ORDER:
                return strictLocalize({
                    id: "Tk8DW5",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Share order"
                        }
                    ]
                });
            case ShareableItemType.INVOICE:
                return strictLocalize({
                    id: "oL6rkF",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Share invoice"
                        }
                    ]
                });
            case ShareableItemType.PRODUCT:
                return strictLocalize({
                    id: "tostat",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Share product"
                        }
                    ]
                });
            default:
                return strictLocalize({
                    id: "Tgs+bE",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Share brand"
                        }
                    ]
                });
        }
    };
    var handleSendEmail = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        trackRetailerTeamManagementSendEmailShareModalButtonClick(pageName);
                        if (selectedUsers.length === 0) {
                            setDropdownErrorMessage(strictLocalize({
                                id: "ohNclW",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Select team member(s) to share with"
                                    }
                                ]
                            }));
                            return [
                                2
                            ];
                        } else {
                            setDropdownErrorMessage(undefined);
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            shareItem([
                                IRetailerShareItemWithTeamMembersRequest.build({
                                    tokens_of_users_to_share_with: selectedUsers.map(function(user) {
                                        return user.user_token;
                                    }).filter(isNotUndefined),
                                    item: IRetailerShareableItem.build({
                                        type: modalType,
                                        note: note,
                                        token: token
                                    })
                                })
                            ])
                        ];
                    case 2:
                        _state.sent();
                        createToast(/*#__PURE__*/ _jsx(Typography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "mWuLOp",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Sent successfully"
                                    }
                                ]
                            })
                        }), {
                            icon: "foundation:CheckOutline",
                            timeout: TOAST_AUTO_DISMISS_TIME_MS
                        });
                        onClose();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setErrorMessage(getWebApiErrorMessage(error, strictLocalize));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendEmail() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCopyLink = function() {
        trackRetailerTeamManagementCopyLinkButtonClick(pageName);
        var window = getWindowOrThrow();
        copyTextToClipboard(window.location.href);
        createToast(/*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "e0OktD",
            defaultMessage: [
                {
                    type: 0,
                    value: "Link copied successfully"
                }
            ]
        }), {
            icon: "foundation:CheckOutline",
            timeout: TOAST_AUTO_DISMISS_TIME_MS
        });
        onClose();
    };
    var _data_users;
    return /*#__PURE__*/ _jsxs(Modal, {
        padding: "88px 24px 24px 24px",
        width: viewport.isTabletAndAbove ? "420px" : undefined,
        onClose: onClose,
        align: "stretch",
        contentStyle: {
            overflow: "visible"
        },
        "data-test-id": "share-with-team-modal",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                children: getModalTitle()
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            isLoadingTeamsData ? /*#__PURE__*/ _jsx(LoadingSpinnerContainer, {
                "data-test-id": "share-with-team-loading-spinner",
                children: /*#__PURE__*/ _jsx(LoadingSpinner, {})
            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    modalType === ShareableItemType.BRAND || modalType === ShareableItemType.PRODUCT ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ _jsx("img", {
                                        src: optimizeImageUrlFillSquare({
                                            url: image === null || image === void 0 ? void 0 : image.url
                                        }, isSSR, 96),
                                        style: {
                                            width: "96px",
                                            height: "96px"
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        size: "2x"
                                    }),
                                    /*#__PURE__*/ _jsxs(Column, {
                                        children: [
                                            /*#__PURE__*/ _jsx(Typography, {
                                                children: name
                                            }),
                                            /*#__PURE__*/ _jsx(Spacer, {
                                                size: 4
                                            }),
                                            /*#__PURE__*/ _jsx(Typography, {
                                                color: Core.text.subdued,
                                                children: subText
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "2x"
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx(SelectTeamUsersDropdown, {
                        options: (_data_users = data === null || data === void 0 ? void 0 : data.users) !== null && _data_users !== void 0 ? _data_users : [],
                        selectedUsers: selectedUsers,
                        onSelect: setSelectedUsers,
                        pageName: pageName,
                        onInviteButtonClick: onInviteButtonClick,
                        errorMessage: dropdownErrorMessage,
                        setErrorMessage: setDropdownErrorMessage
                    }),
                    selectedUsers.length ? /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }) : null,
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(TextArea, {
                            "data-test-id": "share-with-team-note-input",
                            label: strictLocalize({
                                id: "xS1hLZ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Note (optional)"
                                    }
                                ]
                            }),
                            onChange: function(e) {
                                return setNote(e.target.value);
                            },
                            placeholder: strictLocalize({
                                id: "CpOKiv",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Add a note to help your team jump right in"
                                    }
                                ]
                            }),
                            style: {
                                height: "100px",
                                maxHeight: "100px"
                            },
                            value: note
                        })
                    }),
                    errorMessage ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "1x"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                color: Core.text.critical,
                                children: errorMessage
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "4x"
                    }),
                    /*#__PURE__*/ _jsxs(ButtonWrapper, {
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                onClick: handleSendEmail,
                                disabled: isLoadingSendEmail,
                                "data-test-id": "send-email-button",
                                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                    id: "+q2tnY",
                                    defaultMessage: [
                                        {
                                            type: 0,
                                            value: "Send email"
                                        }
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                size: "2x"
                            }),
                            showCopyLinkButton ? /*#__PURE__*/ _jsxs(Button, {
                                variant: "tertiary",
                                onClick: handleCopyLink,
                                children: [
                                    /*#__PURE__*/ _jsx(Link, {}),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        size: 4
                                    }),
                                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "GEEsCV",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Copy share link"
                                            }
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
};
var ButtonWrapper = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-7a2a5a-0"
})([
    ""
]);
var LoadingSpinnerContainer = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-7a2a5a-1"
})([
    "flex-grow:1;width:100%;margin:100px 0;"
]);
